import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonComponent } from './view/_layout/common/common.component';
import { TopNavbarComponent } from './view/_layout/header-navbar/top-navbar.component';
import { HomeComponent } from './view/pages/home/home.component';
import { OurServicesComponent } from './view/pages/our-services/our-services.component';
import { OurProductsComponent } from './view/pages/our-products/our-products.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FooterComponent } from './view/_layout/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from './view/pages/contact/contact.component';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { PagenotFoundComponent } from './view/_layout/pagenot-found/pagenot-found.component';

@NgModule({
  declarations: [
    AppComponent,
    CommonComponent,
    TopNavbarComponent,
    HomeComponent,
    ContactComponent,
    OurServicesComponent,
    OurProductsComponent,
    FooterComponent,
    PagenotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
